enum AppSections {
  'PREPARE_SEARCH_PAGE' = 'PREPARE_SEARCH_PAGE',
  'SEARCH_PAGE' = 'SEARCH_PAGE',
  'ORDER_PAGE' = 'ORDER_PAGE'
}

export { AppSections }
